<div class="basic-information-container">
  <div class="section-header">
    <h2>廠區基本資訊</h2>
  </div>

  <div class="description-panel">
    <p>
      請在下方輸入您廠區的基本資訊，這些資訊將協助 AI 更精確地分析並提供符合您需求的法規建議。
      您可以描述廠區的位置、規模、主要業務、製程與設備等資訊。若您不確定要如何描述，可以點擊下方的產業類型按鈕，系統將自動填入相應的範例格式供您參考修改。
    </p>

    <div class="upload-section">
      <p>
        您也可以直接上傳目前的程序書或相關文件，系統將自動分析並提取關鍵資訊。
      </p>
      <div class="file-upload-container">
        <input type="file" id="documentUpload" (change)="onFileSelected($event)" class="file-input">
        <label for="documentUpload" class="file-upload-btn">
          <i class="fa fa-upload"></i> 上傳文件
        </label>
        <span *ngIf="selectedFile" class="file-name">已選擇: {{selectedFile.name}}</span>
        <button *ngIf="selectedFile && !isAnalyzing" (click)="analyzeFile()" class="analyze-btn">
          <i class="fa fa-search"></i> 進行分析
        </button>
        <div *ngIf="isAnalyzing" class="analyzing-indicator">
          <i class="fa fa-spinner fa-spin"></i> 正在分析中...
        </div>
      </div>
    </div>
  </div>

  <div class="input-section">
    <textarea
      [(ngModel)]="factoryInfo"
      placeholder="請輸入廠區基本資訊..."
      rows="15"
      class="factory-info-textarea">
    </textarea>
  </div>

  <div class="template-section">
    <p>選擇產業類型範本：</p>
    <div class="template-buttons">
      <button
        *ngFor="let template of industryTemplates"
        (click)="applyTemplate(template.industry)"
        class="template-btn">
        {{template.industry}}
      </button>
    </div>
  </div>

  <div class="action-section">
    <button (click)="saveFactoryInfo()" class="save-btn">儲存資訊</button>
  </div>

  <div class="version-section" *ngIf="versions.length > 0">
    <h3>歷史版本</h3>
    <div class="version-list">
      <div *ngFor="let version of versions"
           [class.active]="version.id === currentVersion"
           class="version-item"
           (click)="loadVersion(version.id)">
        <span class="version-number">版本 {{version.id}}</span>
        <span class="version-date">{{version.timestamp | date:'yyyy-MM-dd HH:mm'}}</span>
      </div>
    </div>
  </div>
</div>
